import styled from "@emotion/styled";
import { theme } from "../../../utils/Theme";

export const Container = styled.div``;
